export enum FreemiumTrafficCode {
  FREEMIUM_ONBOARDING = "FREEMIUM_ONBOARDING",
  FREEMIUM_ACCOUNT_FORM = "FREEMIUM_ACCOUNT_FORM",
  FREEMIUM_ACCOUNT_CREATED = "FREEMIUM_ACCOUNT_CREATED",
  FREEMIUM_CONVERSION_RDV_MADE = "FREEMIUM_CONVERSION_RDV_MADE", // prise de rdv via hubspot
  FREEMIUM_CONVERSION_REQUEST_CONTACT = "FREEMIUM_CONVERSION_REQUEST_CONTACT", // prise de rdv via formulaire de conversion à premium
}
